import React, { useState, useEffect } from 'react';

import { languageController } from '../../../../controllers/language/languageController';
import { pushToGTMDataLayer } from '../../../../utils/helpers';

const DealerStar = ({ dealerId, dealerName, onToggle, isStarred, setIsStarred }) => {
  // Initialize starred state by checking the cookie

  const handleClick = () => {
    const newState = !isStarred;
    setIsStarred(newState);
    
    if (newState) {
      // Set cookie when starring
      window.mzFunc?.bakeCookie('preferredDealer', dealerId, 365);
      pushToGTMDataLayer({ event: 'Set Preferred Retailer', dealer: dealerName, action: 'added' });
    } else {
      // Remove cookie when unstarring (if this is the preferred dealer)
      if (window.mzFunc?.checkCookie('preferredDealer') === dealerId.toString()) {
        window.mzFunc?.bakeCookie('preferredDealer', '', -1); // Expire immediately
        pushToGTMDataLayer({ event: 'Set Preferred Retailer', dealer: dealerName, action: 'removed' });
      }
    }
    
    if (onToggle) {
      onToggle(dealerId, newState);
    }
  };

  // Sync with cookie changes from other instances
  useEffect(() => {
    const checkStarState = () => {
      const isCurrentlyStarred = window.mzFunc?.checkCookie('preferredDealer') === dealerId.toString();
      if (isCurrentlyStarred !== isStarred) {
        setIsStarred(isCurrentlyStarred);
      }
    };
    
    // Check periodically (you might want to use event-based updates if available)
    const interval = setInterval(checkStarState, 1000);
    return () => clearInterval(interval);
  }, [dealerId, isStarred]);

  return (
    <div  onClick={handleClick} style={{ cursor: 'pointer' }} className={`mz-dealer-star mz-dealer-star-${isStarred ? 'solid' : 'outline'}`}>
      {!isStarred && <><i className="mz-svg mz-svg--red mz-svg-star_outline"></i> &nbsp;</>}
      {!isStarred && <strong><a className="mz-link">{isStarred ? languageController.getCopy('findDealer','preferred_retailer_on') : languageController.getCopy('findDealer','preferred_retailer_off')}</a></strong>}
       {isStarred && <a className="mz-link caption text--grey">{languageController.getCopy('findDealer','preferred_retailer_on')}</a>}
    </div>
  );
};

export default DealerStar;